import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// API
import { useParticipanteService } from '../../services/participanteServices';

// Estilos
import styles from './participantesallpage.module.css';

function formatarCelular(valor) {
  const numeros = String(valor || '').replace(/\D/g, '');
  if (numeros.length === 11) {
    return numeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return valor || '';
}

function ParticipantesAllPage() {
  const { logout } = useAuth();
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const { showModal } = useModal();
  const navigate = useNavigate();

  const { listarParticipantes, deletarParticipante } = useParticipanteService();

  const [participantes, setParticipantes] = useState([]);

  useEffect(() => {
    const carregarParticipantes = async () => {
      showLoader('Carregando participantes');

      const response = await listarParticipantes();

      if (response.success) {
        const dadosFormatados = (response.data || []).map((participante) => {
          const celular = formatarCelular(participante.celular);
          const nome = participante.nome || 'Participante sem nome';
          return {
            id: participante.id,
            name: celular ? `${nome} - ${celular}` : nome,
          };
        });

        setParticipantes(dadosFormatados);
      } else {
        showToast('Erro ao carregar participantes: ' + (response.message || ''), 3000, 'error');
        if (response.message?.toLowerCase().includes('token')) logout();
      }

      hideLoader();
    };

    carregarParticipantes();
  }, []);

  const handleEditar = (item) => {
    navigate(`/participantes/atualizar/${item.id}`);
  };

  const handleExcluir = (item) => {
    showModal(
      `Excluir ${item.name}?`,
      'Essa ação não poderá ser desfeita.',
      async () => {
        showLoader('Excluindo participante');

        const response = await deletarParticipante(item.id);

        if (response.success) {
          showToast('Participante excluído com sucesso!', 3000, 'success');
          setParticipantes((prev) => prev.filter((p) => p.id !== item.id));
        } else {
          showToast('Falha ao excluir participante.', 3000, 'error');
          if (response.message?.toLowerCase().includes('token')) logout();
        }

        hideLoader();
      },
      () => {
        showToast('Exclusão cancelada.', 2000);
      }
    );
  };

  const handleAdd = () => {
    showToast('O cadastro de participantes deve ser feito pela página de alguma turma.', 3500, 'info');
    navigate('/empresas');
  };

  const handleSelecionar = (item) => {
    navigate(`/participantes/atualizar/${item.id}`);
  };

  return (
    <div className={styles.ParticipantesAllPage}>
      <div className={styles.containerTop}>
        <Breadcrumbs />

        <h1 className={styles.title}>Participantes Cadastrados</h1>

        <FriendlyPhrase page="participantes" />
      </div>

      <div className={styles.containerList}>
        <ItemList
          items={participantes}
          onAdd={handleAdd}
          onEdit={handleEditar}
          onDelete={handleExcluir}
          onClickItem={handleSelecionar}
        />
      </div>
    </div>
  );
}

export default ParticipantesAllPage;
